import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Paper, ListItem, Grid } from '@material-ui/core'

// actions
import { getPluginsList } from '../../../actions/plugins'
import { getKioskSettings, saveKioskSettings } from '../../../actions/kioskSettings'
import { startLoading, stopLoading } from '../../../actions/loading'

// local components
import Kiosk from '../../../components/Kiosk'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
import { EditableSwitch } from '../../../components/common/EditableComponents'
import { getSession } from '../../../utils/api'

const KioskEditable = EditableHOCWrapper(Kiosk)

class KioskContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      companyKioskSetting: {},
    }
  }

  componentDidMount() {
    this.props.dispatch(getPluginsList())
    this.props.dispatch(getKioskSettings()).then((res) => {
      this.setState({
        companyKioskSetting: res,
      })
    })
  }

  onSave = (kioskSettingIndex) => (data, afterOnSave) => {
    this.props.dispatch(startLoading())

    const session = getSession()

    const { assignedShop = {} } = session || {}

    const { companyKioskSetting = {} } = this.state

    let updatedKioskSettings = [...(companyKioskSetting.kioskSetting || [])]

    updatedKioskSettings[kioskSettingIndex] = { ...data, shopId: assignedShop.id }

    this.setState({
      companyKioskSetting: {
        ...companyKioskSetting,
        kioskSetting: [...updatedKioskSettings],
      },
    })

    this.props
      .dispatch(
        saveKioskSettings({
          ...companyKioskSetting,
          shopPluginSettingRequests: [...updatedKioskSettings],
        }),
      )
      .then((response) => {
        afterOnSave(response)
        this.props.dispatch(stopLoading())
      })
  }

  onChange = (key, isCheckbox) => (event) => {
    const { companyKioskSetting = {} } = this.state

    const value = isCheckbox ? event.target.checked : event.target.value

    let updatedKioskSettings = { ...companyKioskSetting }

    updatedKioskSettings = {
      ...updatedKioskSettings,
      [key]: value,
    }

    this.props.dispatch(startLoading())

    this.props.dispatch(saveKioskSettings({ ...updatedKioskSettings })).then((response) => {
      this.props.dispatch(stopLoading())
    })

    this.setState((prevState) => ({
      companyKioskSetting: {
        ...updatedKioskSettings,
      },
    }))
  }

  render() {
    const { list } = this.props.pluginsReducer

    const { session } = this.props.authReducer

    const { lastModified } = this.props.kioskSettingsReducer

    const { companyKioskSetting = {} } = this.state

    const { assignedShop } = session || {}

    let currentKioskSettingIndex =
      companyKioskSetting &&
      companyKioskSetting.kioskSetting &&
      companyKioskSetting.kioskSetting.length &&
      companyKioskSetting.kioskSetting.findIndex((setting) => setting.shopId === assignedShop.id)

    const currentKioskSetting =
      (companyKioskSetting.kioskSetting &&
        companyKioskSetting.kioskSetting[currentKioskSettingIndex]) ||
      {}

    if (currentKioskSettingIndex === -1) {
      currentKioskSettingIndex =
        (companyKioskSetting &&
          companyKioskSetting.kioskSetting &&
          companyKioskSetting.kioskSetting.length) ||
        0
    }

    return (
      <div>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <ListItem>
                <Grid container>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                    Enable Check-In for Company
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin set-width">
                    <EditableSwitch
                      valueToRender={companyKioskSetting.enabled ? 'Enabled' : 'Disabled'}
                      checked={companyKioskSetting.enabled || false}
                      editMode={false}
                      onChange={this.onChange('enabled', true)}
                    />
                  </Grid>
                </Grid>
              </ListItem>
            </Paper>
          </Grid>
        </Grid>
        {companyKioskSetting.enabled ? (
          <KioskEditable
            list={list}
            dataToEdit={currentKioskSetting}
            lastModified={lastModified}
            onSave={this.onSave(currentKioskSettingIndex)}
            assignedShop={assignedShop}
          />
        ) : null}
      </div>
    )
  }
}

const KioskWithTitle = ContainerWithTitle(KioskContainer, 'Check-In')
const KioskConnected = connect(
  ({ dispatch, pluginsReducer, kioskSettingsReducer, authReducer }) => ({
    dispatch,
    pluginsReducer,
    kioskSettingsReducer,
    authReducer,
  }),
)(KioskWithTitle)

export default KioskConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Plugins/Kiosk.js